import { render, staticRenderFns } from "./RespostasAceitas.vue?vue&type=template&id=442cb36d&"
import script from "./RespostasAceitas.vue?vue&type=script&lang=js&"
export * from "./RespostasAceitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports